import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { toDateTime } from '@shared/utils/date-time';
import { DateTime } from 'luxon';

@Pipe({ name: 'appTimePrecise' })
export class AppTimePrecisePipe implements PipeTransform {
    transform(value: DateTime | Date | string): string {
        if (!value) {
            return;
        }

        let instance = toDateTime(value);

        if (!instance.isValid) {
            try {
                instance = DateTime.fromFormat(value as string, 'HH:mm:ss');
            } catch (error) {
                console.error(error);
            }
        }

        if (instance instanceof DateTime && instance.isValid) {
            return instance.toFormat('HH:mm:ss');
        }

        return value as string;
    }
}
